import { InputAdornment, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { validDecimalAndLength } from '../../ModificationsUtils';

export const AllowanceCap = () => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const nameAllowanceCap = 'allowanceCap';
  const allowanceCap: number = useWatch({ name: nameAllowanceCap });
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);

  useEffect(() => {
    if (getValues(nameAllowanceCap)) {
      clearErrors(nameAllowanceCap);
    } else {
      setError(nameAllowanceCap, {});
    }
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={nameAllowanceCap}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(nameAllowanceCap) ?? ''}
          variant="filled"
          label={t('placement.placementMods.AllowanceCap')}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              setValue(nameAllowanceCap, validInput);
              onChange(validInput);
              if (e.target.value) clearErrors(nameAllowanceCap);
            }
          }}
          fullWidth
          color="primary"
          autoComplete="off"
          InputLabelProps={{
            shrink: allowanceCap ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
